import { faCrown, faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { addNewBtn, crownStyles } from './SelectorBarAddNewButton.css';

type SelectorBarAddNewButtonProps = {
  id: string;
  /** Only relevant for personal cards */
  maxCardsReached?: boolean;
  onClick: () => void;
};

export const SelectorBarAddNewButton: React.FC<SelectorBarAddNewButtonProps> = ({
  id,
  maxCardsReached = false,
  onClick,
}) => {
  const status = maxCardsReached ? 'maxReached' : 'maxNotReached';

  return (
    <button className={addNewBtn({ status })} id={id} onClick={onClick} onKeyDown={onClick} tabIndex={0}>
      <FontAwesomeIcon icon={faPlus} width={20} height={20} />
      {maxCardsReached && <FontAwesomeIcon icon={faCrown} className={crownStyles} />}
    </button>
  );
};
